export const CHOICES = [
  { name: 'Rock', img: '/rock.png', beats: ['Scissors', 'Lizard'] },
  { name: 'Paper', img: '/paper.png', beats: ['Rock', 'Spock'] },
  { name: 'Scissors', img: '/scissors.png', beats: ['Paper', 'Lizard'] },
  { name: 'Lizard', img: '/lizard.png', beats: ['Paper', 'Spock'] },
  { name: 'Spock', img: '/spock.png', beats: ['Scissors', 'Rock'] },
];

const BY_NAME = new Map(CHOICES.map((choice) => [choice.name, choice]));

export const OUTCOME_LABELS = {
  win: 'You win!',
  loss: 'You lost!',
  draw: 'Draw!',
};

// Plays one round against a random computer pick.
// Returns { player, computer, outcome } where outcome is a key of OUTCOME_LABELS.
export function playRound(playerName) {
  const player = BY_NAME.get(playerName);
  if (!player) {
    throw new Error(`Unknown choice: ${playerName}`);
  }

  const computer = CHOICES[Math.floor(Math.random() * CHOICES.length)];

  let outcome = 'loss';
  if (player.name === computer.name) {
    outcome = 'draw';
  } else if (player.beats.includes(computer.name)) {
    outcome = 'win';
  }

  return { player, computer, outcome };
}
